import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { CartService } from './cart.service';
import { UtilsService } from '../shared/utils.service';
import { NotificationService } from '../shared/notification.service';
import { IntlService } from '../shared/intl.service';
import { isBrowser } from 'angular2-universal';

declare var $: any;
// declare var isMobile: any;

@Component({
    template: require('./partials/cart-widget.html'),
    selector: 'cart-widget',
    providers: [NotificationService]
})
export class CartWidgetComponent implements OnInit {

    @Input() language: string;
    @Input() labels: any;
    cartContentElement;

    constructor(private notification: NotificationService, public intl: IntlService, public utils: UtilsService, public cartService: CartService, public route: ActivatedRoute, public router: Router) {
    }

    removeFromCart(id){
        this.cartContentElement.css('visibility', 'hidden');
        this.cartService.remove(id);
        this.notification.notify(this.labels.NOTIFICATION[this.language]);
    }

    ngOnInit(){
        if (isBrowser) {
            this.cartContentElement = $(".cart-content");
            if(this.utils.isMobile()){
                this.cartContentElement.addClass("force-hide");
            }
            this.router.events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.cartContentElement.css('visibility', 'hidden');
                }
            });
        }
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cart-widget.component.ts